import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex align-items-center flex-nowrap" }

import { computed, onMounted, onUnmounted, ref } from 'vue';
import { useStore } from 'vuex';
import TokenIcon from './TokenIcon.vue';
import { Token } from '../../sdk/entities/token';


export default /*#__PURE__*/_defineComponent({
  __name: 'TokenGroupIcon',
  props: {
    tokens: null,
    size: null
  },
  setup(__props: any) {

const props = __props as {
  tokens: Token[];
  size?: string;
}



const { state } = useStore();

const tooltipSymbol = ref();
const tokenActive = ref(null);
const isTouch = computed(() => 'ontouchstart' in window || navigator.maxTouchPoints);
const linesCounter = computed(() =>
  state.layout.isTablet ? 1 : Math.ceil(props.tokens.length / 10),
);

const iconSrc = token => {
  return token.iconLink ? token.iconLink : token.tokenIconUrl;
};
const iconSize = computed(() => {
  if (props.size) return props.size;
  else return state.layout.isDesktop ? '16' : '20';
});
const toggleTooltip = (token, event) => {
  if (isTouch.value) tooltipSymbol.value.toggle(event);
};
const showTooltip = (token, event) => {
  tokenActive.value = token;
  if (!isTouch.value) tooltipSymbol.value.show(event);
};
const hideTooltip = () => {
  tokenActive.value = null;
  tooltipSymbol.value.hide();
};
const getTokensLine = (lineNumber: number) => {
  return state.layout.isTablet
    ? props.tokens
    : props.tokens.slice((lineNumber - 1) * 10, lineNumber * 10);
};
onMounted(() => {
  document.addEventListener('scroll', hideTooltip);
});
onUnmounted(() => {
  document.removeEventListener('scroll', hideTooltip);
});

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(linesCounter), (lineNumber) => {
      return (_openBlock(), _createElementBlock("div", { key: lineNumber }, [
        _createElementVNode("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getTokensLine(lineNumber), (token, index) => {
            return (_openBlock(), _createBlock(TokenIcon, {
              key: token.address,
              "icon-src": iconSrc(token),
              symbol: token.symbol,
              size: _unref(iconSize),
              class: _normalizeClass(["token-border", [{ 'token-active z-5': tokenActive.value === token }, { '-ml-s1': index !== 0 }]]),
              onClick: ($event: any) => (toggleTooltip(token, $event)),
              onMouseenter: ($event: any) => (showTooltip(token, $event)),
              onMouseleave: hideTooltip,
              "aria:haspopup": "true",
              "aria-controls": "tooltip_panel"
            }, null, 8, ["icon-src", "symbol", "size", "onClick", "onMouseenter", "class"]))
          }), 128))
        ])
      ]))
    }), 128)),
    _createVNode(_component_OverlayPanel, {
      ref_key: "tooltipSymbol",
      ref: tooltipSymbol,
      class: "tooltip tooltip-text py-s1 px-s2",
      onHide: hideTooltip
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(tokenActive.value ? (tokenActive.value as Token).unwrapWETH().symbol : ''), 1)
      ]),
      _: 1
    }, 512)
  ], 64))
}
}

})